import axios from 'axios';
import {get, isObject, isString} from 'lodash';
const baseURL = `${process.env.GATSBY_STRAPI_FORM_URL}`;
const token = process.env.GATSBY_STRAPI_FORM_TOKEN;

const authInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data"
  },
});


export const postFileData = async (data) => {

  const res = await authInstance.post('upload', data)
  .then((res) => {
    // Success
    if (res.statusText === 'OK') {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })
  return res;

}

export const postFormData = async (data) => {
  const res = await authInstance.post('/stb-forms/forms', data)
  .then((res) => {
    // Success
    if (res.statusText === 'OK') {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })
  
  try{
  let formDatavalues= {};
  for (const pair of data.entries()) {
    if(isString(pair[1])){
      formDatavalues=JSON.parse(pair[1]);
    }
  }
  let email=formDatavalues.email || 'email';
  var current_date = new Date().toJSON().slice(0, -1);
  if(!res || get(res,'success')==false){
      let errorMessage=get(res,'message',"Strapi responsed to fail");
      axios.post('/api/log-form-error', {
        formdata: formDatavalues,
        error: errorMessage,
        email,
      }).catch(e => console.log('log-form-error failed', e));
  }
  }catch(e){
    console.log(91,e);
  }

return res;

}